import React, { Component } from 'react';
import b from 'b_';

import { Researcher } from '@interfaces/researchers-page';

import './researchers.css';
import ResearcherBlock from '@components/researcher';
import EntitiesCarousel from '@components/entities-carousel';

interface ResearchersProps {
    items: Researcher[];
    withSlider?: boolean;
    children?: any;
}

const class_ = b.with('researchers');
export const carouselSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 1
            }
        }
    ]
};

export default class Researchers extends Component<ResearchersProps> {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const { items, children, withSlider } = this.props;

        let researcherList: any = items.map(researcher => (
            <ResearcherBlock key={researcher.id} entity={researcher} />
        ));
        if (withSlider) {
            researcherList = (
                <EntitiesCarousel key="carousel" settings={carouselSettings}>
                    {researcherList}
                    {children}
                </EntitiesCarousel>
            );
        }

        return (
            <div className={class_({ 'with-slider': withSlider })}>
                {researcherList}
            </div>
        );
    }
}
